import moment from "moment";
import { _global } from "../../helpers";
import { changeToTitleCase } from "../../utils/convertionUtils";

export const INBOX_EXPORT_COLUMNS = [
  { header: "Last Message Date", width: 18 },
  { header: "Initial Message Date", width: 20 },
  { header: "Attachment", width: 12 },
  { header: "Member Name", width: 28 },
  { header: "Client Name", width: 28 },
  { header: "Member ID", width: 18 },
  { header: "Vendor", width: 20 },
  { header: "Member Email", width: 34 },
  { header: "Phone", width: 16 },
  { header: "Subject", width: 60 },
  { header: "Member Follow Up Message Count", width: 32 },
  { header: "Current Age (days)", width: 20 },
];

const pad = (value) => String(value).padStart(2, "0");

const buildExportStamp = (date) => {
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absOffset = Math.abs(offsetMinutes);
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}-${pad(date.getMinutes())}-${pad(date.getSeconds())}` +
    `${sign}${pad(Math.floor(absOffset / 60))}-${pad(absOffset % 60)}`
  );
};

// Hyphens stand in for ISO 8601 colons, which Windows does not allow in file names.
// A member inbox uses a generic name so the member's name and ID stay out of the file name.
export const buildInboxExportFileName = (date = new Date(), member = {}) => {
  const stamp = buildExportStamp(date);
  const isMemberExport = Boolean(member?.memberUuid || member?.sequencedMemberId);
  const prefix = isMemberExport ? "Member_Inbox" : "CSR_Inbox";
  return `${prefix}_${stamp}.xlsx`;
};

const toExcelDate = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.startOf("day").toDate() : "";
};

const hasAttachment = (attachments) =>
  (!isNaN(attachments) && attachments > 0) || (Array.isArray(attachments) && attachments.length > 0);

const getMemberName = (conversation, member) => {
  if (conversation.member) {
    const fullName = [conversation.member.firstName, conversation.member.lastName].filter(Boolean).join(" ");
    return changeToTitleCase(fullName) || "";
  }
  return (member && changeToTitleCase(member.name)) || "";
};

export const currentAgeInDays = (initialMessageDate, asOf = new Date()) => {
  const initial = moment(initialMessageDate);
  if (initialMessageDate === null || initialMessageDate === undefined || initialMessageDate === "" || !initial.isValid()) {
    return "";
  }
  return moment(asOf).startOf("day").diff(initial.startOf("day"), "days");
};

// Follow-ups are extra member messages after the opening message of the current exchange.
// Blank when missing or zero so the export only highlights rows with follow-ups.
export const memberFollowUpMessageCount = (memberMessageCount) => {
  if (memberMessageCount === null || memberMessageCount === undefined || memberMessageCount === "") {
    return "";
  }
  const count = Number(memberMessageCount);
  if (!Number.isFinite(count) || count < 2) return "";
  return count - 1;
};

export const mapConversationToExportRow = (conversation, member = {}, asOf = new Date()) => {
  const conversationMember = conversation.member || {};
  const lastMessage = conversation.lastMessage || {};
  return [
    toExcelDate(lastMessage.createdTimestamp),
    toExcelDate(conversation.currentMemberRequestInitialMessageDate),
    hasAttachment(lastMessage.attachments) ? "Yes" : "",
    getMemberName(conversation, member),
    member.clientName || conversationMember.clientName || "",
    String(member.sequencedMemberId || conversationMember.sequencedMemberId || ""),
    conversationMember.memberHccId || member.memberHccId ? "HealthRules Payer" : "Javelina",
    member.email || conversationMember.emailAddress || "",
    _global.formatPhoneNumber(member.phone || conversationMember.phoneNumber) || "",
    conversation.topic || "",
    memberFollowUpMessageCount(conversation.currentMemberRequestMessageCount),
    currentAgeInDays(conversation.currentMemberRequestInitialMessageDate, asOf),
  ];
};
